import { render, staticRenderFns } from "./ItsBaseJobType.vue?vue&type=template&id=968e3bcc&scoped=true&"
import script from "./ItsBaseJobType.vue?vue&type=script&lang=js&"
export * from "./ItsBaseJobType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "968e3bcc",
  null
  
)

export default component.exports